<template>
  <div class="FormSections">
    <FormSection
      v-for="(section, index) in sectionsOrdered"
      :key="index"
      :article="article"
      :section="section"
      :sectionCount="sectionCount"
      @remove="remove(section)"
      @update:section="update(index, $event)" />
    <div v-if="sectionTemplatesAvailable.length" class="specOptions">
      <BoxSectionTemplate
        v-for="sectionTemplate in sectionTemplatesAvailable"
        :key="sectionTemplate.id"
        :sectionTemplate="sectionTemplate"
        @click.native="create(sectionTemplate)">
        <Btn class="sm success light" :isLoading="isCreating">
          {{ $t('add') }}
        </Btn>
      </BoxSectionTemplate>
    </div>
  </div>
</template>

<script>
import { actions, getters } from '@utils'
import { byAsc, normalizePositionKey, removeItem } from '@utils/collections'
import { pluck, sort, update } from 'rambda'
import BoxSectionTemplate from './BoxSectionTemplate'
import FormSection from './FormSection'

export default {
  components: {
    BoxSectionTemplate,
    FormSection,
  },
  props: {
    article: Object,
    sections: Array,
  },
  data() {
    return {
      isCreating: false,
    }
  },
  computed: {
    sectionCount() {
      return this.sections.length
    },
    sectionsOrdered() {
      return sort(byAsc('position'), this.sections)
    },
    sectionTemplatesAvailable() {
      const sectionTemplateIds = pluck('sectionTemplateId', this.sections)

      return this
        .sectionTemplates
        .filter(specType => !sectionTemplateIds.includes(specType.id))
    },
    ...getters(
      'sectionFactory',
      'sectionTemplates',
    ),
  },
  methods: {
    async create({ id, name: title }) {
      this.$wrap(async () => {
        const section = this.sectionFactory({
          articleId: this.article.id,
          position: this.sectionCount,
          sectionTemplateId: id,
          siteId: this.article.siteId,
          title,
        })

        const sectionCreated = await this
          .CREATE_SECTION(section)

        this.setSections([
          ...this.sections,
          {
            ...sectionCreated,
            facts: [],
          },
        ])
      }, 'isCreating')
    },
    setSections(sections) {
      this.$up('sections', sections)
    },
    remove(sectionToRemove) {
      const sections = removeItem(sectionToRemove, this.sections)
        .map(section => ({
          ...section,
          position: section.position > sectionToRemove.position
            ? section.position - 1
            : section.position,
        }))
      this.setSections(sections)
    },
    update(index, section) {
      const sections = update(index, section, this.sections)

      this.setSections(normalizePositionKey(sections))
    },
    ...actions('CREATE_SECTION'),
  },
}
</script>

<style lang="scss">
.FormSections {
  .specOptions {
    border: 2px dashed $success-light;
    border-radius: $radius;
    display: flex;
    padding: $grid-unit $grid-unit 0;

    .BoxSpec {
      @include trans;
      max-width: 12rem;

      .Btn {
        border-radius: 0;
      }

      &:last-of-type {
        height: min-content;
        margin-right: 0;
      }

      &:hover {
        background: $success-lighter;
        color: $success-darker;
        cursor: pointer;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "add": "Add"
  }
}
</i18n>
